import { MenuItem, Select, SelectProps } from '@mui/material';

type QuantityDropdownProps = Omit<SelectProps, 'value' | 'onChange'> & {
  availableQuantity: number;
  value: number;
  onChange: (value: number) => void;
};

export const QuantityDropdown = ({
  availableQuantity,
  value,
  onChange,
  ...props
}: QuantityDropdownProps) => {
  return (
    <Select
      size='small'
      value={value}
      required
      onChange={(e) => onChange(Number(e.target.value))}
      {...props}
    >
      {Array(Math.min(availableQuantity, 10))
        .fill(0)
        .map((_, i) => (
          <MenuItem key={i} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
    </Select>
  );
};
